export const ABI = {
    prediction: require('./abi.json'),
    referrals: require('./abi_referrals.json'),
    // prediction_old: require('./abi_v1.2.json'),
};
